<div class="cmxa-product-tab">
  <app-product-tab-title [title]="'Master ' + masterTableTitle"
                         [badgeCount]="(products$| async)?.length">
  </app-product-tab-title>
  <div class="cmxa-product-tab__content">
    <app-main-primeng-table [id]="'cmxa-all-bmc-products-table'"
                            [dataKey]="'id'"
                            [rowData]="products$ | async"
                            [tableType]="TABLE_TYPE.MASTER_PRODUCTS"
                            [selectionMode]="TABLE_SELECTION_MODE.MULTIPLE"
                            [disabledRowSelectionResolver]="disabledRowSelectionResolver"
                            (selectionChange)="selectedProduct($event)">
    </app-main-primeng-table>

    <adapt-alert [config]="alertConfig" class="mt-2">
      Compatibility information is only available to customers when the Product status is <b>Available</b> or <b>Support
      Only</b> and the compatibility data Publishing status is <b>Published</b>.
    </adapt-alert>

    <div class="cmxa-confirm-btns__wrap">
      <button id="cmxa-cancel-add-new-products"
              adapt-button
              btn-type="tertiary"
              size="default"
              (click)="onCancelAddingNewProducts()">
        <span>Cancel</span>
      </button>
      <button id="cmxa-apply-add-new-products"
              adapt-button
              btn-type="info"
              size="default"
              [disabled]="selectedProducts.length < 1"
              (click)="onApplyAddingNewProducts()">
        <span>Apply</span>
      </button>
    </div>
  </div>
</div>
